import React from 'react';
import CloseButton from './CloseButton';
import DraggableFilter from './DraggableFilter';
import LogOp from './LogOp';
import { dragAndDropFunctions } from './Functions';
import { getGranularitiesFromNodes } from './filterFunctions';

function DropBlock(props) {
    const {
        id,
        className,          // filterType: 'ISW' | 'IGW'
        granularity,
        allowablefilters,
        filterNodes = [],   // FilterNode[] rendered from state
        onDrop,             // (filterNode, targetBlockId) => void
        onRemove,           // (nodeId) => void
        onLogOpChange,      // (nodeId, newOp) => void
        onRemoveBlock,      // () => void — removes this block itself
    } = props;

    const filterType = className;

    function handleDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        const raw = ev.dataTransfer.getData('text/filter');
        if (!raw) return;
        try {
            const filterNode = JSON.parse(raw);
            if (onDrop) onDrop(filterNode, id);
        } catch (e) {
            console.error('DropBlock: failed to parse dropped filter', e);
        }
        ev.target.closest && ev.target.closest('.dropZone')?.classList.remove('available');
    }

    function handleDragStart(ev) {
        const granularities = getGranularitiesFromNodes(filterNodes);
        dragAndDropFunctions.startDrag(ev, filterType, granularities, null);
        ev.dataTransfer.setData('text/filter', JSON.stringify({
            kind: 'block',
            id,
            filterType,
            children: filterNodes,
        }));
        ev.dataTransfer.effectAllowed = 'move';
    }

    function renderNode(node) {
        if (node.kind === 'logOp') {
            return (
                <LogOp
                    key={node.id}
                    id={node.id}
                    operator={node.operator}
                    onLogOpChange={newOp => onLogOpChange && onLogOpChange(node.id, newOp)}
                />
            );
        }
        if (node.kind === 'filter') {
            return (
                <DraggableFilter
                    key={node.id}
                    filter={node}
                    className={filterType}
                    onRemove={() => onRemove && onRemove(node.id)}
                />
            );
        }
        if (node.kind === 'block') {
            return (
                <DropBlock
                    key={node.id}
                    id={node.id}
                    className={filterType}
                    granularity={granularity}
                    filterNodes={node.children}
                    onDrop={onDrop}
                    onRemove={onRemove}
                    onLogOpChange={onLogOpChange}
                    onRemoveBlock={() => onRemove && onRemove(node.id)}
                />
            );
        }
        return null;
    }

    return (
        <div
            className={`dropZone ${id} ${filterType}`}
            id={id}
            granularity={granularity}
            allowablefilters={allowablefilters}
            draggable={true}
            onDragStart={handleDragStart}
            onDragEnd={dragAndDropFunctions.endDrag}
            onDragOver={(ev) => { ev.preventDefault(); ev.dataTransfer.dropEffect = 'copy'; }}
            onDrop={handleDrop}
        >
            {filterNodes.map(renderNode)}
            <CloseButton onRemove={onRemoveBlock} />
        </div>
    );
}

export default DropBlock;